<div class="container-fluid">
  <div class="col-md-12">
    <div class="breadcrumb-title border-0 mb-3">
      <div
        class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
      >
        <mat-icon color="primary">dashboard_2</mat-icon>
        <p class="mb-0">{{"APPCOMPONENT.MENU.APPS_DASHBOARD" | translate}}</p>
        <mat-icon
          class="cursor-pointer ms-1"
          color="primary"
          matTooltip="PDF"
          matTooltipPosition="right"
          (click)="captureScreen()"
        >
          picture_as_pdf
        </mat-icon>
      </div>
    </div>
  </div>

  <div
    *ngIf="applicationname !== 'SUPOSHIT DAHOD WORKER'; else dahodDashboard"
    class="row"
    id="pdfmake"
  >
    <!-- Existing form cards -->
    <ng-container *ngIf="formList && formList.length > 1; else singleRecord">
      <div
        *ngFor="let e of formList; let i = index; trackBy: trackByForm"
        class="col-12 col-lg-6 mb-1 px-2"
      >
        <app-dashboard-charts
          [tittle]="e['title']"
          [tab_index]="i"
          [attributesList]="e['fields']"
          [userstoryId]="e['userstoryId']"
          [formId]="e['id']"
          [appId]="e['appId']"
          [loadDelay]="getLoadDelay(i)"
        >
        </app-dashboard-charts>
      </div>
    </ng-container>

    <ng-template #singleRecord>
      <app-dashboard-charts
        *ngIf="formList && formList.length > 0"
        [tittle]="formList[0].title"
        [tab_index]="0"
        [attributesList]="formList[0].fields"
        [userstoryId]="formList[0].userstoryId"
        [formId]="formList[0].id"
        [loadDelay]="0"
        oneRecord="1"
      >
      </app-dashboard-charts>
    </ng-template>

    <!-- ✅ Reports with addOnDashboardReport = 1 -->
    <ng-container *ngIf="reportList && reportList.length > 0">
      <div *ngFor="let report of reportList" class="col-12 col-lg-6 mb-1 px-2">
        <div class="card radius-10 mb-3">
          <div class="card-header">
            <h6 class="m-0 p-2">{{ report.title }}</h6>
          </div>
          <div class="card-body p-1">
            <app-view-report
              [flag]="true"
              [searchdata]="report.dataJson"
              [uiformid]="report.uiFormId"
              [reportId]="report.id"    
              [searchList]="report.searchList"
              [uiFormData]="report.dataJson?.data"
              [autoUpdateReport]="report.autoUpdateReport"
            >
            </app-view-report>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #dahodDashboard>
    <app-dahod-dashboard></app-dahod-dashboard>
  </ng-template>
</div>



<!--     [titlereport]="report.title" -->
